import * as _ from 'underscore'
import { IconSet } from './iconSet'
import { IIcons as IIcons_Mvc, Icons as Icons_Mvc } from 'mappMvc/const'

export interface IIcons extends IIcons_Mvc {
	Browser: string;
	Cache: string;
	ConnectionSection: string;
	Content: string;
	Download: string;
	Filter: string;
	GIS: string;
	Home: string;
	Imagery: string;
	Import: string;
	Invalid: string;
	Launch: string;
	Layers: string;
	Legend: string;
	Logs: string;
	MApps: string;
	Mobile: string;
	OverViews: string;
	Password: string;
	PrintLayouts: string;
	Publish: string;
	PublishVector: string;
	PublishWmts: string;
	Queries: string;
	Refresh: string;
	Security: string;
	Services: string;
	SpatialModels: string;
	Stats: string;
	StyleSets: string;
	Sync: string;
	Table: string;
	TileGrid: string;
	Upload: string;
	User: string;
	Users: string;
	VectorData: string;
	WorkflowEditor: string;
	Workflows: string; 
}; 

export var Icons: IIcons = _.extend({}, Icons_Mvc, {
	Browser: IconSet.Web,
	Cache: IconSet.Cache,
	ConnectionSection: IconSet.Database,
	Content: IconSet.Content,
	Download: IconSet.Download,
	Filter: IconSet.Filter,
	GIS: IconSet.GIS,
	Home: IconSet.Home,
	Imagery: IconSet.Imagery,
	Import: IconSet.Import,
	Invalid: IconSet.Invalid,
	Launch: IconSet.Launch,
	Layers: IconSet.Layers,
	Legend: IconSet.Legend,
	Logs: IconSet.Logs,
	MApps: IconSet.MApps,
	Mobile: IconSet.Phone,
	OverViews: IconSet.OverView,
	Password: IconSet.Key,
	PrintLayouts: IconSet.PrintLayouts,
	Publish: IconSet.Publish,
	PublishVector: IconSet.PublishVector,
	PublishWmts: IconSet.PublishWmts,
	Queries: IconSet.Queries,
	Refresh: IconSet.Refresh,
	Security: IconSet.User,
	Services: IconSet.Services,
	SpatialModels: IconSet.SpatialModels,
	Stats: IconSet.Time,
	StyleSets: IconSet.StyleSets,
	Sync: IconSet.Refresh,
	Table: IconSet.Table,
	TileGrid: IconSet.TileGrid,
	Upload: IconSet.Upload,
	User: IconSet.User,
	Users: IconSet.Users,
	VectorData: IconSet.VectorData,
	WorkflowEditor: IconSet.Workflows,
	Workflows: IconSet.Workflows 
});